import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    item: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadComputeDetail';
export const computeDetailActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const computeDetailLoadAction = (workspaceId, computeName) => {
    return {
        type: computeDetailActionTypes.LOAD,
        payload: { workspaceId: workspaceId, computeName: computeName },
    };
};
export const computeDetailLoadingAction = (payload) => {
    return {
        type: computeDetailActionTypes.LOADING,
        payload: payload,
    };
};
export const computeDetailLoadedAction = (payload, result) => {
    return {
        type: computeDetailActionTypes.LOADED,
        payload: {
            item: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case computeDetailActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { item: Object.assign(Object.assign({}, state.item), { status: AsyncRequestStatus.Pending }) });
        case computeDetailActionTypes.LOADED:
            const loadedAction = action;
            return Object.assign(Object.assign({}, state), { item: loadedAction.payload.item });
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=ComputeDetail.ducks.js.map
